import { render, staticRenderFns } from "./CommunicationValidationDialog.vue?vue&type=template&id=7c465e77"
import script from "./CommunicationValidationDialog.vue?vue&type=script&lang=js"
export * from "./CommunicationValidationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports